<template>
  <div class="container">
    <div
      class="services__directory"
      ref="alpha"
      v-show="showAlpha"
    >
      <div class="container">
        <div class="services__directory-alpha">
          <div
            @click="setActiveAlpha(alpha)"
            v-for="alpha in alphabet"
            :key="alpha"
            class="services__directory-alpha-item"
            :class="{
              'services__directory-alpha-item--active': activeAlpha === alpha,
            }"
          >
            {{ alpha }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <template v-if="!showAlpha && showNavigation && !loading">
    <div class="page-subnavigation">
      <div class="page-subnavigation__container">
        <div class="page-subnavigation__items-wrapper">
          <div class="page-subnavigation__items">
            <a
              v-for="(item, itemIndex) in items"
              :key="itemIndex"
              @click="setActive(item)"
              :class="{
                active: active && active.url === item.url,
              }"
              class="page-subnavigation__item"
              >{{ item.title }}</a
            >
          </div>
          <div class="page-subnavigation__gradient-overlay"></div>
        </div>
      </div>
    </div>
    <ServicesSecondLevelDesktop
      v-if="active && active.children"
      :items="active.children"
    />
  </template>
  <template v-if="!showAlpha && !showNavigation && !loading">
    <ServicesSecondLevelDesktop :items="items" />
  </template>
  <template v-if="showAlpha && !loading">
    <ServicesAlphaDesktop :items="items" />
  </template>
</template>

<script>
import ServicesSecondLevelDesktop from "./ServicesSecondLevelDesktop.vue";
import ServicesAlphaDesktop from "./ServicesAlphaDesktop.vue";
import { store } from "../../store.js";

export default {
  props: ["showNavigation", "items", "loading"],
  components: {
    ServicesSecondLevelDesktop,
    ServicesAlphaDesktop,
  },
  data() {
    return {
      active: null,
    };
  },
  mounted() {
    if (this.items && this.items.length > 0) {
        
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has('subcategory')) {
                this.items.forEach((item, index) => {
                    searchParams.get(item.title)
                    if (item.title === searchParams.get('subcategory')) {
                        this.setActive(item)
                    }
                })
            }

            if (this.active === null) {
                this.setActive(this.items[0]);
            }
    }
  },
  computed: {
    alphabet: function () {
      const alpha = Array.from(Array(26)).map((e, i) => i + 65);
      const alphabet = alpha.map((x) => String.fromCharCode(x));
      return alphabet;
    },
    showAlpha: function () {
      return store.serviceShowAlpha;
    },
    activeAlpha: function () {
      return store.serviceActiveAlpha;
    },
  },
  watch: {
    items: function () {
      this.$nextTick(() => {
        this.active = null;
        store.serviceOverview = null;

        
      });
    },
  },
  methods: {
    setActiveAlpha: function (alpha) {
      store.serviceActiveAlpha = alpha;

      // Use the alpha value to identify the section's ID
      var itemId = alpha;

      this.$nextTick(() => {
        var element = document.getElementById(itemId);
        if (!element) return; // If the element doesn't exist, do nothing

        var headerOffset = 100;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      });
    },
    setActive: function (item) {
      if (this.active && this.active.url === item.url) {
        this.active = null;
      } else {
        this.active = item;
      }
    },
  },
};
</script>
